import { ActionReducerMap } from '@ngrx/store';
import { commonReducers, CommonState, stateKey as commonKey } from '@app/core/store/common.slice';
import { feedbackReducers, FeedbackState, stateKey as feedbackKey } from './feedback.slice';

export const coreReducers: ActionReducerMap<CoreState> = {
  [commonKey]: commonReducers,
  [feedbackKey]: feedbackReducers,
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CoreState {
  [commonKey]: CommonState;
  [feedbackKey]: FeedbackState;
}
